import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { SnippetRetentionMetadataResponse } from '../../../../shared/snippets';

import { getSnippetsBaseQueryKey } from './shared';

async function getSnippetRetentionMetadata(locator: string) {
  return get<SnippetRetentionMetadataResponse>(`/api/revisions/${nuc(locator)}/snippets/retention/metadata`, false);
}

export const getSnippetRetentionMetadataQueryKey = (locator: string) => [...getSnippetsBaseQueryKey(locator), 'retention', 'metadata'];

/**
 * useSnippetRetentionMetadata is a hook that fetches and returns the snippet source code
 * retention metadata for a given user revision locator.
 */
export function useSnippetRetentionMetadata(
  locator: string,
) {
  return useQuery<SnippetRetentionMetadataResponse>({
    queryKey: getSnippetRetentionMetadataQueryKey(locator),
    queryFn: () => getSnippetRetentionMetadata(locator),
  });
}
